import { createApp } from 'vue'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './index.css'

// Import pages
import TraceDetail from './pages/TraceDetail.vue'
import TestTrace from './pages/TestTrace.vue'

const routes = [
  { path: '/:traceId', component: TraceDetail },
  { path: '/trace/:traceId', component: TraceDetail },
  { path: '/test', component: TestTrace },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

const app = createApp(App)
app.use(router)
app.mount('#root')